export const consts = {
    'gender': [
        // {'value': 0, 'text': 'Не выбрано'},
        { 'value': 1, 'text': 'Мужской' },
        { 'value': 2, 'text': 'Женский' }
    ],
    'family_status': [
        { 'value': 0, 'text': 'Не выбрано' },
        { 'value': 1, 'text': 'Не женат/не замужем' },
        { 'value': 2, 'text': 'Встречаюсь' },
        { 'value': 3, 'text': 'Помолвлен(а)' },
        { 'value': 4, 'text': 'Женат/замужем' },
        { 'value': 5, 'text': 'В гражданском браке' },
        { 'value': 6, 'text': 'Влюблен(а)' },
        { 'value': 7, 'text': 'Всё сложно' }
    ],
    'show_birthday': [
        { 'value': 0, 'text': 'Не показывать дату' },
        { 'value': 1, 'text': 'Показывать дату' },
        { 'value': 2, 'text': 'Не показывать год рождения' }
    ],
    'political_preferences': [
        { 'value': 0, 'text': 'Не выбрано' },
        { 'value': 1, 'text': 'Умеренные' },
        { 'value': 2, 'text': 'Индифферентные' },
        { 'value': 3, 'text': 'Коммунистические' },
        { 'value': 4, 'text': 'Социалистические' },
        { 'value': 5, 'text': 'Либеральные' },
        { 'value': 6, 'text': 'Консервативные' },
        { 'value': 7, 'text': 'Монархические' }
    ],
    'worldview': [
        { 'value': 0, 'text': 'Не выбрано' },
        { 'value': 1, 'text': 'Иудаизм' },
        { 'value': 2, 'text': 'Православие' },
        { 'value': 3, 'text': 'Католицизм' },
        { 'value': 4, 'text': 'Протестантизм' },
        { 'value': 5, 'text': 'Ислам' },
        { 'value': 6, 'text': 'Буддизм' },
        { 'value': 7, 'text': 'Конфуцианство' },
        { 'value': 8, 'text': 'Светский гуманизм' }
    ],
    'main_in_life': [
        { 'value': 0, 'text': 'Не выбрано' },
        { 'value': 1, 'text': 'Семья и дети' },
        { 'value': 2, 'text': 'Карьера и деньги' },
        { 'value': 3, 'text': 'Развлечения и отдых' },
        { 'value': 4, 'text': 'Наука и исследования' },
        { 'value': 5, 'text': 'Совершенствование мира' },
        { 'value': 6, 'text': 'Саморазвитие' },
        { 'value': 7, 'text': 'Красота и искусство' },
        { 'value': 8, 'text': 'Слава и влияние' }
    ],
    'main_in_people': [
        { 'value': 0, 'text': 'Не выбрано' },
        { 'value': 1, 'text': 'Ум и креативность' },
        { 'value': 2, 'text': 'Доброта и честность' },
        { 'value': 3, 'text': 'Красота и здоровье' },
        { 'value': 4, 'text': 'Власть и богатство' },
        { 'value': 5, 'text': 'Смелость и упорство' },
        { 'value': 6, 'text': 'Юмор и жизнелюбие' }
    ],
    'attitudes': [
        { 'value': 0, 'text': 'Не выбрано' },
        { 'value': 1, 'text': 'Резко негативное' },
        { 'value': 2, 'text': 'Негативное' },
        { 'value': 3, 'text': 'Компромиссное' },
        { 'value': 4, 'text': 'Нейтральное' },
        { 'value': 5, 'text': 'Положительное' }
    ],
    'attitude_towards_alcohol': [
        { 'value': 0, 'text': 'Не выбрано' },
        { 'value': 1, 'text': 'Резко негативное' },
        { 'value': 2, 'text': 'Негативное' },
        { 'value': 3, 'text': 'Компромиссное' },
        { 'value': 4, 'text': 'Нейтральное' },
        { 'value': 5, 'text': 'Положительное' }
    ],
    'attitude_towards_smoking': [
        { 'value': 0, 'text': 'Не выбрано' },
        { 'value': 1, 'text': 'Резко негативное' },
        { 'value': 2, 'text': 'Негативное' },
        { 'value': 3, 'text': 'Компромиссное' },
        { 'value': 4, 'text': 'Нейтральное' },
        { 'value': 5, 'text': 'Положительное' }
    ],
    'countries': [
        { 'value': 0, 'text': 'Не выбрана' },
        { 'value': 1, 'text': 'Россия' },
        { 'value': 2, 'text': 'Украина' },
        { 'value': 3, 'text': 'Беларусь' },
        { 'value': 4, 'text': 'Казахстан' }
    ],
    'cities': [
        { 'value': 0, 'text': 'Не выбран' },
        { 'value': 1, 'text': 'Москва' },
        { 'value': 2, 'text': 'Санкт-Петербург' },
        { 'value': 3, 'text': 'Краснодар' },
        { 'value': 'other', 'text': 'другой' }
    ],
    'districts': [
        { 'value': 0, 'text': 'Не выбрано' },
        { 'value': 1, 'text': 'Восточное Дегунино' },
        { 'value': 2, 'text': 'Лосиноостровский' },
        { 'value': 3, 'text': 'Северное Орехово-Борисово' }
    ],
    'subway': [
        { 'value': 0, 'text': 'Не выбрано' },
        { 'value': 1, 'text': 'Библиотека имени Ленина' },
        { 'value': 2, 'text': 'Электрозаводская' },
        { 'value': 3, 'text': 'Фили' }
    ],
    'schools': [
        { 'value': 0, 'text': 'Не выбрано' },
        { 'value': 1, 'text': 'Школа №1' },
        { 'value': 2, 'text': 'Школа №2' },
        { 'value': 3, 'text': 'Школа-гимназия имени Ломоносова' }
    ],
    'universities': [
        { 'value': 0, 'text': 'Не выбрано' },
        { 'value': 1, 'text': 'МИСиС' },
        { 'value': 2, 'text': 'МГТУ им. Н. Э. Баумана' },
        { 'value': 3, 'text': 'МСХА имени К.А. Тимирязева' }
    ],
    'months': [
        'января',
        'февраля',
        'марта',
        'апреля',
        'мая',
        'июня',
        'июля',
        'августа',
        'сентября',
        'октября',
        'ноября',
        'декабря',
    ],
    'shortMonths': [
        'янв',
        'фев',
        'мар',
        'апр',
        'мая',
        'июн',
        'июл',
        'авг',
        'сен',
        'окт',
        'ноя',
        'дек',
    ],
    'relatives': [
        { 'key': 'grandparents', 'label': 'Дедушки и бабушки' },
        { 'key': 'parents', 'label': 'Родители' },
        { 'key': 'siblings', 'label': 'Братья и сестры' },
        { 'key': 'children', 'label': 'Дети' },
        { 'key': 'grandchildren', 'label': 'Внуки' }
    ],
    'education': [
        { 'value': 0, 'text': 'Не выбрано' },
        { 'value': 1, 'text': 'Среднее' },
        { 'value': 2, 'text': 'Среднее специальное' },
        { 'value': 3, 'text': 'Неполное высшее' },
        { 'value': 4, 'text': 'Высшее' },
        { 'value': 5, 'text': 'Два или более высших' },
    ],
    'height': [
        { 'value': 0, 'text': 'Не выбрано' },
        { 'value': 1, 'text': 'Низкий' },
        { 'value': 2, 'text': 'Ниже среднего' },
        { 'value': 3, 'text': 'Средний' },
        { 'value': 4, 'text': 'Выше среднего' },
        { 'value': 5, 'text': 'Высокий' }
    ],
    'weight': [
        { 'value': 0, 'text': 'Не выбрано' },
        { 'value': 1, 'text': 'До 40 кг' },
        { 'value': 2, 'text': '40 - 50 кг' },
        { 'value': 3, 'text': '50 - 60 кг' },
        { 'value': 4, 'text': '60 - 70 кг' },
        { 'value': 5, 'text': '70 - 80 кг' },
        { 'value': 6, 'text': '80 - 90 кг' },
        { 'value': 7, 'text': '90 - 100 кг' },
        { 'value': 8, 'text': '100 - 110 кг' },
        { 'value': 9, 'text': '110 - 120 кг' },
        { 'value': 10, 'text': '120 - 130 кг' },
        { 'value': 11, 'text': '130 - 140 кг' },
        { 'value': 12, 'text': '140 - 150 кг' },
        { 'value': 13, 'text': '150+ кг' },
    ],
    'body_type': [
        { 'value': 0, 'text': 'Не выбрано' },
        { 'value': 1, 'text': 'Худощавое' },
        { 'value': 2, 'text': 'Обычное' },
        { 'value': 3, 'text': 'Спортивное' },
        { 'value': 4, 'text': 'Мускулистое' },
        { 'value': 5, 'text': 'Плотное' },
        { 'value': 6, 'text': 'Полное' }
    ],
    'amount_of_children': [
        { 'value': 0, 'text': 'Не выбрано' },
        { 'value': 1, 'text': 'Нет' },
        { 'value': 2, 'text': 'Один ребенок' },
        { 'value': 3, 'text': 'Два ребёнка' },
        { 'value': 4, 'text': 'Три ребёнка' },
        { 'value': 5, 'text': 'Больше трех' }
    ],
    'acquaintance_goal': [
        { 'value': 0, 'text': 'Не выбрано' },
        { 'value': 1, 'text': 'Дружба, общение' },
        { 'value': 2, 'text': 'Переписка' },
        { 'value': 3, 'text': 'Отношения' },
        { 'value': 4, 'text': 'Флирт' },
        { 'value': 5, 'text': 'Брак, создание семьи' },
        { 'value': 6, 'text': 'Совместная игра' }
    ],
    'smoking': [
        { 'value': 0, 'text': 'Не выбрано' },
        { 'value': 1, 'text': 'Не курю' },
        { 'value': 2, 'text': 'Почти не курю' },
        { 'value': 3, 'text': 'Бросаю курить' },
        { 'value': 4, 'text': 'Курю' },
    ],
    'alcohol': [
        { 'value': 0, 'text': 'Не выбрано' },
        { 'value': 1, 'text': 'Не пью вообще' },
        { 'value': 2, 'text': 'Пью в компаниях изредка' },
        { 'value': 3, 'text': 'Люблю выпить' }
    ],
    'wheel': [
        1, 29, 36, 24, 10, 4, 19, 8, 3, 12, 34, 6, 14, 11, 7, 22, 32, 5, 35, 0, 2, 9, 13, 18, 20, 21, 15, 16, 17, 25, 26, 27, 31, 23, 30, 28, 33
    ],
    'card_ranks': ['6', '7', '8', '9', '10', 'J', 'Q', 'K', 'A'],
    'languages': [
        "Абазинский",
        "Абенаки",
        "Абхазский",
        "Аварский",
        "Авестийский",
        "Авнги",
        "Агульский",
        "Адыгейский",
        "Азербайджанский",
        "Аймара",
        "Айнийский",
        "Айнский",
        "Аканский",
        "Аккадский",
        "Алабамский",
        "Албанский",
        "Алеутский",
        "Алжирский",
        "Алтайский",
        "Амаракери",
        "Амисский",
        "Амхарский",
        "Английский",
        "Англосаксонский",
        "Андийский",
        "Анута",
        "Апачский",
        "Арабела",
        "Арабский",
        "Арагонский",
        "Арамейский",
        "Аранский",
        "Аранта",
        "Арапахо",
        "Аргобба",
        "Армянский",
        "Арнаутский",
        "Арумынский",
        "Арчинский",
        "Ассамский",
        "Астурийский",
        "Атаяльский",
        "Афарский",
        "Африкаанс",
        "Ахомский",
        "Багата",
        "Багвалинский",
        "Балийский",
        "Бамана (Бамбара)",
        "Банива",
        "Бантава",
        "Баскский",
        "Басса",
        "Бахаса синама",
        "Башкирский",
        "Беджа",
        "Белорусский",
        "Белуджский",
        "Бемба",
        "Бенч",
        "Бикольский",
        "Бислама",
        "Блэкфут",
        "Болгарский",
        "Бора",
        "Боснийский",
        "Бретонский",
        "Будухский",
        "Бурушаски",
        "Бурятский",
        "Бутанский",
        "Бухидский",
        "Бходжпури",
        "Ваи",
        "Вайандот",
        "Валлийский",
        "Валлонский",
        "Варлпири",
        "Ваханский",
        "Венда",
        "Венетский",
        "Вепсский",
        "Вик-мунгкан",
        "Виратури",
        "Водский",
        "Волапюк",
        "Выруский",
        "Вьетнамский",
        "Греческий",
        "Грузинский",
        "Гуахиро",
        "Дари",
        "Датский",
        "Джерсийский",
        "Динка",
        "Долуо",
        "Дуала",
        "Дусунский",
        "Египетский диалект арабского",
        "Западнофризский",
        "Ибанский",
        "Иврит",
        "Ижорский",
        "Илоканский",
        "Ингушский",
        "Индонезийский",
        "Ирландский",
        "Исландский",
        "Испанский",
        "Итальянский",
        "Кабардино-черкесский",
        "Кабильский",
        "Кабувердьяну",
        "Каинганг",
        "Кайюга",
        "Калмыцкий",
        "Канури",
        "Капампанган",
        "Караимский",
        "Каракалпакский",
        "Карамоджонг",
        "Карачаево-балкарский",
        "Карельский",
        "Карийский",
        "Каталанский",
        "Кекчи",
        "Кельтиберский",
        "Кечуа",
        "Китайский",
        "Команчский",
        "Коптский",
        "Корейский",
        "Корнский",
        "Кофан",
        "Кхмерский",
        "Ладинский",
        "Лазский",
        "Лезгинский",
        "Ливанский",
        "Литовский",
        "Македонский",
        "Мальдивский",
        "Монгольский",
        "Немецкий",
        "Нидерландский",
        "Норвежский",
        "Оромо",
        "Персидский",
        "Польский",
        "Португальский",
        "Румынский",
        "Русский",
        "Себуанский",
        "Сербский",
        "Сефардский",
        "Сирийский",
        "Трукский (чуукский)",
        "Турецкий",
        "Туркменский",
        "Уаб-мето",
        "Удмуртский",
        "Узбекский",
        "Украинский",
        "Уме-саамский",
        "Урду",
        "Финский",
        "Французский",
        "Хорватский",
        "Цимбрский",
        "Чавакано",
        "Чакма",
        "Чамалинский",
        "Чаморро",
        "Чамский",
        "Чаха",
        "Чева",
        "Чеченский",
        "Чешский",
        "Чикасо",
        "Чипевиан",
        "Чоктавский",
        "Чувашский",
        "Чукотский",
        "Шайенский",
        "Шведский",
        "Эльзасский диалект",
        "Эстонский",
        "Эстремадурский",
        "Ямайский",
        "Яо",
        "Японский",
    ],
    'emoji': [
        '😁',
        '😂',
        '😃',
        '😄',
        '😅',
        '😆',
        '😉',
        '😊',
        '😋',
        '😌',
        '😍',
        '😏',
        '😒',
        '😓',
        '😔',
        '😖',
        '😘',
        '😚',
        '😜',
        '😝',
        '😞',
        '😠',
        '😡',
        '😢',
        '😣',
        '😤',
        '😥',
        '😨',
        '😩',
        '😪',
        '😫',
        '😭',
        '😰',
        '😱',
        '😲',
        '😳',
        '😵',
        '😷',
        '😸',
        '😹',
        '😺',
        '😻',
        '😼',
        '😽',
        '😾',
        '😿',
        '🙀',
        '🙅',
        '🙆',
        '🙇',
        '🙈',
        '🙉',
        '🙊',
        '🙋',
        '🙌',
        '🙍',
        '🙎',
        '🙏'
    ]
}
